



























































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { DxButton, DxLoadIndicator, DxLookup, DxRadioGroup, DxCheckBox, DxScrollView, DxTextArea } from 'devextreme-vue';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import { DxTagBox } from 'devextreme-vue/tag-box';
import { Popup, AlertMessage } from '@questelservices/common-vue';
import { QuestelServicesClient, RequestResult } from '@questelservices/common';
import { ClientService } from '../../service/ClientService';
import { ClientDto } from '../../models/client/ClientDto';
import { SelectOption } from '../../models/SelectOption';
import { uniqBy, sortBy } from 'lodash';
import { BrowseSelectionDataDto } from '../../models/browse-mode/BrowseSelectionDataDto';
import { CreateMatterWorkDto } from '../../models/browse-mode/CreateMatterWorkDto';
import string from '@/utilities/String';
import { MatterWorkTypeEnum } from '@/models/matter-work/MatterWorkTypeEnum';

@Component({
  components: {
    DxButton,
    DxPopup,
    DxLoadIndicator,
    DxLookup,
    DxRadioGroup,
    DxCheckBox,
    DxScrollView,
    DxTagBox,
    DxToolbarItem,
    DxTextArea,
    AlertMessage
  }
})
export default class BrowseModeSelectionDialog extends Vue {
  private showDialog: boolean = false;
  
  errorMessage: string = '';
  loadingCases: boolean = false;
  
  get loadCasesButtonOptions(): any {
    return {
      disabled: !this.clientDataReady || this.loadingCases,
      text: 'Load Cases',
      type: 'default',
      stylingMode: 'contained',
      onClick: this.loadCases,
    };
  }

  clients: ClientDto[] = [];
  clientsLoaded: boolean = false;

  clientData: BrowseSelectionDataDto[] = [];
  clientDataLoading: boolean = false;
  get clientDataReady() : boolean {
    return this.clientData && this.clientData.length > 0;
  }

  confidentRadioOptions: any[] = [
    { value: null, text: 'All Cases' },
    { value: false, text: 'Low Confidence Only' },
    { value: true, text: 'High Confidence Only' },
  ];

  clientId: Guid | null = null;
  batchId: Guid | null = null;
  countryIds: number[] = [];
  agentIds: Guid[] = [];
  filingTypeId: number | null = null;
  phaseTypeId: number | null = null;
  isConfident: boolean | null = null;
  hasInternalNotes: boolean = false;
  hasReportLanguage: boolean = false;
  claimSet: boolean = false;
  notes: string = '';
  useCustomNotes: boolean = false;
  userReviewedMode: boolean = false;
  
  @Watch('clientId')
  onClientIdChanged(value: Guid | null, oldValue: Guid | null) {
    this.resetAllExceptClientId();
    this.clientData = [];
    if(value != null) {      
      this.clientDataLoading = true;
      this.client.get<BrowseSelectionDataDto[]>(`/api/ActivityPlanner/browse-selection-data/${value}`)
        .then(data => {
          this.clientData = data;
          this.clientDataLoading = false;
        })
        .catch(this.handleDataLoadingError);
    }
  }

  private handleDataLoadingError(result: any) {
    let message = result && result.Message
      ? ' Error Message: <br /><br />' + result.Message
      : '';

    this.errorMessage = 'An error occurred loading data. Please try again, or contact support if the error continues.' + message;
  }

  private filterClientData() : (data: BrowseSelectionDataDto[], field: 'batch' | 'country' | 'agent' | 'filingType' | 'phase') => BrowseSelectionDataDto[] {
    return (data, field) => {
      if (field !== 'batch') {
        data = data.filter(d => this.batchId == null || this.batchId == d.BatchId);
      }

      if (field !== 'country') {
        data = data.filter(d => this.countryIds.length === 0 || this.countryIds.includes(d.CountryId));
      }

      if (field !== 'agent') {
        data = data.filter(d => this.agentIds.length === 0 || this.agentIds.includes(d.AgentId));
      }

      if (field !== 'filingType') {
        data = data.filter(d => this.filingTypeId == null || this.filingTypeId == d.FilingTypeId);
      }

      if (field !== 'phase') {
        data = data.filter(d => this.phaseTypeId == null || this.phaseTypeId == d.PhaseTypeId);
      }

      return data;
    }
  }

  private sortSelectOptions(data: SelectOption[], sortDescending: boolean = false) : SelectOption[] {
    let uniqueData = uniqBy(data, d => d.value);
    let sortedData = sortBy(uniqueData, d => d.text);
    if(sortDescending) {
      sortedData = sortedData.reverse();
    }
    return sortedData;
  }

  get batches() : SelectOption[] {
    return this.sortSelectOptions(this.filterClientData()(this.clientData, 'batch').map(d => {
      return {
        text: d.BatchName,
        value: d.BatchId
      };
    }), true);
  }

  get countries() : SelectOption[] {
    return this.sortSelectOptions(this.filterClientData()(this.clientData, 'country').map(d => {
      return {
        text: d.CountryCode,
        value: d.CountryId
      };
    }));
  }

  get agents() : SelectOption[] {
    return this.sortSelectOptions(this.filterClientData()(this.clientData, 'agent').map(d => {
      return {
        text: d.AgentName,
        value: d.AgentId
      };
    }));
  }

  get filingTypes() : SelectOption[] {
    let filteredData = this.filterClientData()(this.clientData, 'filingType');
    let uniqueData = uniqBy(filteredData, d => d.FilingTypeId);
    let sortedData = sortBy(uniqueData, d => d.FilingTypeId);
    return sortedData.map(d => {
      return {
        text: d.FilingTypeName,
        value: d.FilingTypeId
      };
    });
  }

  get phaseTypes(): SelectOption[] {
    let filteredData = this.filterClientData()(this.clientData, 'phase').filter(d => d.PhaseTypeId != null);
    let uniqueData = uniqBy(filteredData, d => d.PhaseTypeId);
    let sortedData = sortBy(uniqueData, d => d.PhaseTypeOrder);
    return sortedData.map(d => {
      // The nulls were filtered out, so declare these are the right type
      return {
        text: d.PhaseTypeName as string,
        value: d.PhaseTypeId as number
      };
    });
  }

  getPostData(): CreateMatterWorkDto {
    return {
      MatterWorkType: MatterWorkTypeEnum.Coding,
      // this.clientId should not be null at this point, so declare it as the right type
      ClientId: this.clientId as Guid,
      BatchId: this.batchId,
      CountryIds: this.countryIds,
      AgentIds: this.agentIds,
      FilingTypeId: this.filingTypeId,
      PhaseTypeId: this.phaseTypeId,
      IsConfident: this.isConfident,
      HasInternalNotes: this.hasInternalNotes,
      HasReportLanguage: this.hasReportLanguage,
      ClaimSet: this.claimSet,
      Notes: this.notes,
      UserReviewedMode: this.userReviewedMode
    }
  }

  private client: QuestelServicesClient = new QuestelServicesClient(this.$store, '');
  private clientService: ClientService = new ClientService();

  mounted() : void {
    this.clientService.getAll().then(clients => {
      this.clients = clients;
      this.clientsLoaded = true;
    })
    .catch(this.handleDataLoadingError);
  }

  private reset() : void {
    this.clientId = null;
    this.resetAllExceptClientId();
  }

  private resetAllExceptClientId() : void {
    this.batchId = null;
    this.countryIds = [];
    this.agentIds = [];
    this.phaseTypeId = null;
    this.isConfident = null;
    this.hasInternalNotes = false;
    this.hasReportLanguage = false;
    this.claimSet = false;
    this.errorMessage = '';

    if (!this.useCustomNotes) {
      this.notes = '';
    }
  }

  filterValueChanged(e: any) {
    if (this.useCustomNotes) {
      return;
    }

    let parts: string[] = [];

    if (this.batchId != null) {
      let batch = this.batches.find(b => b.value === this.batchId);
      if (batch != null) {
        parts.push(batch.text);
      }
    }

    if (this.countryIds.length > 0) {
      let countries: string[] = [];
      this.countryIds.forEach(countryId => {
        let country = this.countries.find(c => c.value === countryId);
        if (country != null) {
          countries.push(country.text);
        }
      });

      if (countries.length > 0) {
        parts.push(sortBy(countries).join(', '));
      }
    }

    if (this.agentIds.length > 0) {
      let agents: string[] = [];
      this.agentIds.forEach(agentId => {
        let agent = this.agents.find(a => a.value === agentId);
        if (agent != null) {
          agents.push(agent.text);
        }
      });

      if (agents.length > 0) {
        parts.push(sortBy(agents).join(', '));
      }
    }

    if (this.filingTypeId != null) {
      let filingType = this.filingTypes.find(f => f.value === this.filingTypeId);
      if (filingType != null) {
        parts.push(filingType.text);
      }
    }

    if (this.phaseTypeId != null) {
      let phaseType = this.phaseTypes.find(p => p.value === this.phaseTypeId);
      if (phaseType != null) {
        parts.push(phaseType.text);
      }
    }

    if (this.isConfident != null) {
      if (this.isConfident) {
        parts.push('HC');
      } else {
        parts.push('LC');
      }
    }

    if (this.hasInternalNotes) {
      parts.push('Has Internal Notes');
    }

    if (this.hasReportLanguage) {
      parts.push('Has Report Language');
    }

    this.notes = parts.join(', ');
  }

  notesChange() {
    this.useCustomNotes = !string.isNullOrEmpty(this.notes);
  }

  private async loadCases() : Promise<any> {
    this.errorMessage = '';
    this.loadingCases = true;
    this.client.getPostData<RequestResult<{MatterWorkId: Guid, Cases: number}>>('/api/MatterWorks', this.getPostData())
      .then(result => {
        if(result.Success) {          
          this.$router.push({ name: 'phase-assignment', params: { id: result.Data!.MatterWorkId as string } }); 
        } else if(result.Message) {
          this.errorMessage = result.Message
        }
      })
      .catch(this.handleDataLoadingError)
      .finally(() => {
        this.loadingCases = false;
      });
  }

  show() {
    this.showDialog = true;
  }

  private hidingPopup(): void {
    this.reset();
  }
}
